import { Box, Text, Center } from "@chakra-ui/react";

const Footer = () => {
  return (
    <footer>
      <Center>
        {/* <Text>&copy; 2024, Octogrub Website</Text> */}
      </Center>
    </footer>
  );
};

export default Footer;
